import { extendStarterTrial } from "../backendapi/workspaceApi";
import { showErrorModal } from "../scripts/react/components/ErrorModal.jsx";

export async function handleExtendTrial(workspaceId: string) {
    eventTracker?.event({
        type: "Trial Termination decision",
        data: { workspaceId, decision: "extend trial" }
    });
    try {
        const response = await extendStarterTrial(workspaceId);
        if (response.success) {
            window.location.reload();
        } else {
            showErrorModal({
                title: "Error Extending Trial",
                message: "Please try again or contact help@roboflow.com if the issue persists."
            });
        }
    } catch {
        showErrorModal({
            title: "Error Extending Trial",
            message: "Please try again or contact help@roboflow.com if the issue persists."
        });
    }
}
